import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { translate } from "admin-on-rest";
import shouldUpdate from "recompose/shouldUpdate";
import compose from "recompose/compose";
import ContentCreate from "material-ui/svg-icons/content/create";
import IconButton from "material-ui/IconButton";
//import linkToRecord from "./linkToRecord";
import { cyan500 } from "material-ui/styles/colors";

const EditButton = ({
  basePath = "",
  label = "aor.action.edit",
  record = {},
  translate
}) => (
  <IconButton
    iconStyle={{ color: cyan500 }}
    containerElement={
      <Link
        to={{
          pathname: `${basePath}/${encodeURIComponent(record.id)}`,
          state: record
        }}
      />
    }
  >
    <ContentCreate />
  </IconButton>
);

EditButton.propTypes = {
  basePath: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func.isRequired
};

const enhance = compose(
  shouldUpdate(
    (props, nextProps) =>
      (props.record &&
        nextProps.record &&
        props.record.id !== nextProps.record.id) ||
      props.basePath !== nextProps.basePath ||
      (props.record == null && nextProps.record != null)
  ),
  translate
);

export default enhance(EditButton);



// WEBPACK FOOTER //
// ./src/components/button/EditButton.js